import React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import { toast } from 'react-toastify';
import { XraySchema } from "../../schema/XraySchema";
import xrayMachineServices from "../../services/xrayMachine.services";

const initialValues = {
    name: '',
    center_id:'',
    description:''
}

const XrayMachineForm = ({ toggle, isAddMode, getData, selectedRow, centers}) => {  
     const savedValues = {
        name: selectedRow?.name,
        center_id:selectedRow?.center_id||'',
        description: selectedRow?.description

    }
    const onSubmit = async (values) => {
        const reqBody = {
            name: values.name,
            center_id: values.center_id,
            description: values.description
        }
       if(isAddMode==='Add'){
        const result = await xrayMachineServices.creatApi(reqBody);
        if (result.data.status === true) {
            // actions.resetForm();
            getData()
            toggle()
            toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
        }
    }else{
        const reqBody = {
            name: values.name,
            center_id: values.center_id,
            description: values.description
        }
        const result = await xrayMachineServices.updateApi(selectedRow?._id,reqBody)
        if (result.data.status === true) {
            // actions.resetForm();
            getData()
            toggle()
            toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode==='Add'?initialValues:savedValues}
                validationSchema={XraySchema('ADD_XRYMACHINE')}
                onSubmit={onSubmit}
                enableReinitialize
            >
                <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Record' : 'Update Record'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                            <div className="col-md-12">
                                <label htmlFor="center_id" className="form-label"> Select Center</label>
                                    <Field as='select' className='form-select' id="center_id" name="center_id" >
                                        <option  disabled value="">Select Center</option>
                                        {
                                            centers.map((e, key) => {
                                                return <option key={key} value={e._id}>{e.name}</option>;
                                            })
                                        }
                                    </Field>
                                    <ErrorMessage name='center_id' component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="name" className="form-label">
                                        X-ray Machine Name
                                    </label>
                                    <Field type="text" className="form-control" id="name" name='name'
                                    />
                                    <ErrorMessage name='name' component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="description" className="form-label">
                                        Description
                                    </label>
                                    <Field type="text" className="form-control" id="description" name='description'
                                    />
                                    <ErrorMessage name='description' component={TextError} />
                                </div>
                               
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                            {isAddMode==="Add"? "Save":"Update"}
                        </button>
                    </ModalFooter>
                </Form>

            </Formik>
        </React.Fragment>
    );
}

export default XrayMachineForm;